import { Building2 } from 'lucide-react';

import RestaurantEmptyState from '../../shared/RestaurantEmptyState';

const WasteBranchEmpty = () => {
  return (
    <RestaurantEmptyState
      icon={Building2}
      title="No hay sucursales disponibles"
      description="Para registrar mermas de restaurante, primero debe existir una sucursal activa donde se controle el inventario."
      hint="Configure una sucursal antes de continuar"
    />
  );
};

export default WasteBranchEmpty;
